import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'

import { Column, Text } from 'Components/UI'

import { DiffAddedGlyph, DiffRemovedGlyph } from 'Assets/Svg/Icons'

import { CollapseContainer, GroupButton } from './styles'

type Props = {
  question?: string
  answer?: string
}

function FaqSectionAccordionQuestion({ answer, question }: Props) {
  const [isUnfolded, setIsUnfolded] = useState(false)

  if (!question || !answer) return null

  return (
    <Column gap={5}>
      <GroupButton
        unfolded={isUnfolded}
        onClick={() => setIsUnfolded(prevState => !prevState)}
      >
        {isUnfolded ? DiffRemovedGlyph() : DiffAddedGlyph()}

        <Text as="h4" body16 left medium title>
          {question}
        </Text>
      </GroupButton>

      <CollapseContainer
        animate={{ height: isUnfolded ? 'auto' : 0 }}
        initial={{ height: 0 }}
      >
        <ReactMarkdown>{answer}</ReactMarkdown>
        {/*<Text body body16 ml={11} semiLight>*/}
        {/*</Text>*/}
      </CollapseContainer>
    </Column>
  )
}

export default FaqSectionAccordionQuestion
